import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {RoomParty} from '../../../graphql/groups.datatypes';

interface RoomPartiesData {
    roomPartiesInMyGroup: void,
    myRoomParties: void,
    roomParties: {
        data: RoomParty[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const gqlRoomParty = `
    id
    start_date
    end_date

    members {
        id

        groupMember {
            id
            first_name
            last_name
        }
    }

    booking {
        id
        created_at
        group {
            id
            name
            booking_form_url
        }
    }
`;

export const GET_ROOM_PARTIES_QUERY = gql`
  query roomParties($count: Int!, $page: Int!, $where: WhereConditions, $hasGroupBooking: QueryRoomPartiesHasGroupBookingWhereHasConditions, $orderBy: [OrderByClause!]){
    roomParties(first: $count, page: $page, where: $where, hasGroupBooking: $hasGroupBooking, orderBy: $orderBy){
      data {
        ${gqlRoomParty}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getRoomParties = (count: number, page: number, where?: any, orderBy?: any, hasGroupBooking?: any) => useQuery<RoomPartiesData>(
    GET_ROOM_PARTIES_QUERY,
    {
        variables: {
            count,
            page,
            where,
            hasGroupBooking,
            orderBy,
        },
    }
);

export default getRoomParties;
